<template>
    <div class="view view__auth_validatekey">
        <auth-validate-key/>
    </div>
</template>

<script>

import AuthValidateKey from '@/components/auth/validatekey/AuthValidateKey'
export default {
  name: 'view-auth-validate-key',
  components: { AuthValidateKey },
  beforeDestroy () {
    this.$store.dispatch('authUserClearValidateKey')
  }
}
</script>
